import { render, staticRenderFns } from "./campaign-google-step2.vue?vue&type=template&id=22c00a62&scoped=true"
import script from "./campaign-google-step2.vue?vue&type=script&lang=js"
export * from "./campaign-google-step2.vue?vue&type=script&lang=js"
import style0 from "./campaign-google-step2.vue?vue&type=style&index=0&id=22c00a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c00a62",
  null
  
)

export default component.exports